import { Pipe, PipeTransform } from '@angular/core';
import { Dokument } from '../../../../shared/models/dokument';

@Pipe({
  name: 'shouldShowNoAttachments',
  standalone: true,
})
export class ShouldShowNoAttachmentsPipe implements PipeTransform {
  transform(document: Dokument | null | undefined): boolean {
    return !document?.zalaczniki?.length;
  }
}
